<div class="pcl-shell" (click)="fecharDropdown()">
  <div *ngIf="mensagemCentral"
       style="position:fixed;inset:0;z-index:2000000;display:flex;align-items:center;justify-content:center;pointer-events:none">
    <div style="background:rgba(30,41,59,0.85);color:#fff;padding:8px 18px;border-radius:8px;font-size:12.5px;font-weight:500;box-shadow:0 4px 16px rgba(0,0,0,0.2);text-align:center">
      {{ mensagemCentral }}
    </div>
  </div>
  <div class="container">

    <!-- ── PAGE HEADER (mesmo padrão da Venda) ── -->
    <div class="page-header">
      <div class="page-header-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 0 1-8 0"/>
        </svg>
      </div>
      <div style="flex:1">
        <h1>Pedidos de Compra</h1>
        <p>Consulte e acompanhe os pedidos gerados</p>
      </div>
      <button type="button" class="btn-imprimir"
              [disabled]="pedidoSelecionado == null"
              (click)="onImprimir()"
              [title]="pedidoSelecionado == null ? 'Selecione um pedido para imprimir' : 'Imprimir pedido #' + pedidoSelecionado">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="6 9 6 2 18 2 18 9"/>
          <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
          <rect x="6" y="14" width="12" height="8"/>
        </svg>
        Imprimir{{ pedidoSelecionado != null ? ' #' + pedidoSelecionado : '' }}
      </button>
      <button type="button" class="btn-novo" (click)="novoPedido.emit()">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
        Novo Pedido
      </button>
      <div class="header-funcoes" (click)="$event.stopPropagation()">
        <button type="button" class="btn-config" (click)="toggleFuncoesMenu($event)" title="Funções">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
          </svg>
        </button>
        <div class="pcf-funcoes-menu" *ngIf="funcoesMenuAberto">
          <button type="button" class="pcf-funcoes-item" (click)="gerarPedidosAbaixoPontoPedido(false)">Gerar Pedidos com Itens abaixo do Ponto de Pedido</button>
          <button type="button" class="pcf-funcoes-item" (click)="gerarPedidosAbaixoPontoPedido(true)">Gerar Pedidos com Itens abaixo do Ponto de Pedido e com Vendas</button>
          <div class="pcf-funcoes-separador"></div>
          <button type="button" class="pcf-funcoes-item" (click)="exportarExcel()">Exportar Dados para Excel</button>
          <button type="button" class="pcf-funcoes-item" (click)="exportarCsv()">Exportar Dados para CSV</button>
          <button type="button" class="pcf-funcoes-item" (click)="copiarParaAreaDeTransferencia()">Copiar Dados para Área de Transferência</button>
        </div>
      </div>
    </div>

    <!-- ── FILTROS ── -->
    <div class="filtros-bar">

      <!-- Busca rápida — fornecedor/CNPJ/comprador -->
      <div class="filtro-busca-rapida filtro-busca-rapida--destaque">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <input type="text" class="input-busca-rapida"
               placeholder="Filtrar por código, tipo, fornecedor, CNPJ ou comprador..."
               [(ngModel)]="termoBusca"
               (ngModelChange)="onTermoBuscaChange()">
        <button *ngIf="termoBusca" type="button" class="busca-limpar" (click)="termoBusca=''; onTermoBuscaChange()">✕</button>
      </div>

      <!-- Busca por PN / Descrição -->
      <div class="filtro-busca-rapida filtro-busca-pn">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <input type="text" class="input-busca-rapida"
               placeholder="Buscar por PN ou descrição..."
               [(ngModel)]="termoBuscaPn"
               (ngModelChange)="onTermoBuscaPnChange()">
        <button *ngIf="termoBuscaPn" type="button" class="busca-limpar" (click)="termoBuscaPn=''; buscar()">✕</button>
      </div>

      <!-- Separador -->
      <div class="filtro-divisor"></div>

      <div class="filtro-grupo">
        <label>De</label>
        <input type="date" class="input-data" [(ngModel)]="dtDe">
      </div>
      <div class="filtro-grupo">
        <label>Até</label>
        <input type="date" class="input-data" [(ngModel)]="dtAte">
      </div>
      <button type="button" class="btn-buscar" (click)="buscar()" [disabled]="carregando"><app-loading-indicator *ngIf="carregando" size="inline"></app-loading-indicator>
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        {{ carregando ? 'Buscando...' : 'Buscar' }}
      </button>

      <!-- Separador -->
      <div class="filtro-divisor"></div>

      <!-- Checkbox cancelados -->
      <label class="filtro-toggle" (click)="$event.stopPropagation()">
        <input type="checkbox" [(ngModel)]="mostrarCancelados" (ngModelChange)="onMostrarCanceladosChange()">
        <span class="toggle-label">Exibir cancelados</span>
      </label>
    </div>

    <!-- ── ERRO ── -->
    <div *ngIf="erro" class="alerta alerta-erro">{{ erro }}</div>

    <!-- ── TABELA ── -->
    <div class="tabela-card">
      <div *ngIf="carregando" class="loading-row">
        <app-loading-indicator></app-loading-indicator>
        <span>Carregando pedidos de compra...</span>
      </div>

      <div *ngIf="!carregando && pedidosFiltrados.length === 0" class="vazio-row">
        Nenhum pedido de compra encontrado.
      </div>

      <ng-container *ngIf="!carregando && pedidosFiltrados.length > 0">
        <table class="tabela">
          <thead>
            <tr>
              <th class="th-ordenavel" (click)="ordenar('nunota')" title="Clique para ordenar">Código<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='nunota'">{{ ordenarCampo==='nunota' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-center th-ordenavel" (click)="ordenar('status')" title="Clique para ordenar">Status<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='status'">{{ ordenarCampo==='status' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-center th-ordenavel" (click)="ordenar('numTitulo')" title="Clique para ordenar">Nº Título<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='numTitulo'">{{ ordenarCampo==='numTitulo' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-center th-ordenavel" (click)="ordenar('prioridade')" title="Clique para ordenar">Prioridade<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='prioridade'">{{ ordenarCampo==='prioridade' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-center th-ordenavel" (click)="ordenar('codemp')" title="Clique para ordenar">Empresa<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='codemp'">{{ ordenarCampo==='codemp' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-center th-ordenavel" (click)="ordenar('tipo')" title="Clique para ordenar">Tipo<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='tipo'">{{ ordenarCampo==='tipo' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('dtmov')" title="Clique para ordenar">Solicitação<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='dtmov'">{{ ordenarCampo==='dtmov' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('comprador')" title="Clique para ordenar">Solicitante<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='comprador'">{{ ordenarCampo==='comprador' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('observacao')" title="Clique para ordenar">Observação<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='observacao'">{{ ordenarCampo==='observacao' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('docparc')" title="Clique para ordenar">CNPJ<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='docparc'">{{ ordenarCampo==='docparc' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('fornecedor')" title="Clique para ordenar">Fornecedor<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='fornecedor'">{{ ordenarCampo==='fornecedor' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-right th-ordenavel" (click)="ordenar('vlr')" title="Clique para ordenar">Valor R$<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='vlr'">{{ ordenarCampo==='vlr' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-right th-ordenavel" (click)="ordenar('vlrusd')" title="Clique para ordenar">Valor U$<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='vlrusd'">{{ ordenarCampo==='vlrusd' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel th-quebra" (click)="ordenar('pcrIdAerosys')" title="Clique para ordenar">Nº Ped.<br>Aerosys<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='pcrIdAerosys'">{{ ordenarCampo==='pcrIdAerosys' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-center col-acoes-th">Ações</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let p of pedidosPagina">
            <tr class="linha-clicavel"
                [class.linha-cancelada]="p.status === 'Cancelado'"
                [class.linha-selecionada]="pedidoSelecionado === p.nunota"
                (click)="selecionarLinha($event, p)"
                (dblclick)="onDblClickLinha(p)" title="Clique para selecionar | Duplo clique para editar">
              <td class="col-nunota"><a class="link-itens" (click)="abrirItens($event, p)" (dblclick)="$event.stopPropagation()" title="Clique para ver os itens do pedido">{{ p.nunota }}</a></td>
              <td class="col-center">
                <span class="status-badge" [ngClass]="statusLegadoClass(p.gplStatus)">{{ p.gplStatus || '—' }}</span>
              </td>
              <td class="col-center">{{ p.numTitulo || '—' }}</td>
              <td class="col-center">{{ p.prioridade || '—' }}</td>
              <td class="col-center">
                <span class="empresa-badge"
                  [style.background]="empresa.corClaraPorCodEmp(p.codemp, 0.82)"
                  [style.border-left]="'3px solid ' + empresa.corPorCodEmp(p.codemp)"
                  [title]="p.empresa">{{ fmtCodEmp(p.codemp) }}</span>
              </td>
              <td class="col-center">
                <span class="tipo-badge" [ngClass]="tipoClass(p.tipoGpl)">{{ fmtTipo(p.tipoGpl) }}</span>
              </td>
              <td class="col-data">{{ p.dtmov }}</td>
              <td class="col-vend" [title]="p.comprador">{{ p.comprador }}</td>
              <td class="col-obs">
                <span class="obs-texto" [title]="p.observacao">{{ p.observacao }}</span>
              </td>
              <td class="col-cnpj">{{ p.docparc }}</td>
              <td class="col-cliente" [title]="p.fornecedor">{{ p.fornecedor }}</td>
              <td class="col-right col-valor">{{ fmtBrl(vlrTotal(p)) }}</td>
              <td class="col-right col-valor">{{ fmtUsd(vlrTotalUsd(p)) }}</td>
              <td class="col-center col-pedaero">{{ p.pcrIdAerosys ?? '—' }}</td>
              <td class="col-center col-acoes" (click)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
                <div class="dropdown-wrapper">
                  <button class="btn-dots" [class.btn-dots-ativo]="dropdownAberto === p.nunota" (click)="toggleDropdown($event, p)" title="Ações">⋮</button>
                  <div class="dropdown-menu" *ngIf="dropdownAberto === p.nunota" (click)="$event.stopPropagation()">
                    <div class="dropdown-header">Pedido #{{ p.nunota }}</div>
                    <button class="dropdown-item item-editar"
                      (click)="editarPedido.emit(p.nunota); dropdownAberto = null">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                      {{ podeEditar(p) ? 'Editar Pedido' : 'Visualizar Pedido' }}
                    </button>
                    <div class="dropdown-separador"></div>
                    <div class="dropdown-subtitulo">Status</div>
                    <button class="dropdown-item" [disabled]="!podeAutorizar(p)" (click)="alterarStatus(p, 'AUTORIZAR')">Autorizar</button>
                    <button class="dropdown-item" [disabled]="!podeCancelarPedido(p)" (click)="alterarStatus(p, 'CANCELAR')">Cancelar pedido</button>
                    <button class="dropdown-item" [disabled]="!podeEstornar(p)" (click)="alterarStatus(p, 'ESTORNAR')">Estornar</button>
                    <div class="dropdown-separador"></div>
                    <button class="dropdown-item" [disabled]="!podeCancelarItensEmAberto(p)"
                      [title]="podeCancelarItensEmAberto(p) ? '' : 'Disponível apenas para pedidos com status PARCIAL'"
                      (click)="cancelarItensAbertos(p)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
                      Cancelar itens em aberto
                    </button>
                    <button class="dropdown-item" [disabled]="!podeCancelarItemSelecionado(p)"
                      [title]="tituloCancelarItemSelecionado(p)" (click)="cancelarItemSelecionado(p)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
                      {{ rotuloCancelarSelecionados(p) }}
                    </button>
                    <button class="dropdown-item" [disabled]="!podeDesmembrarItem(p)"
                      [title]="tituloDesmembrarItem(p)" (click)="desmembrarItem(p)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 3h5v5"/><path d="M8 3H3v5"/><path d="M21 3l-7 7"/><path d="M3 3l7 7"/><path d="M12 12v9"/></svg>
                      Desmembrar item
                    </button>
                    <div class="dropdown-separador"></div>
                    <button class="dropdown-item" [disabled]="!podeReabrirItens(p)"
                      [title]="tituloReabrirItens(p)" (click)="reabrirTodosItens(p)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
                      Reabrir todos os itens cancelados
                    </button>
                    <button class="dropdown-item" [disabled]="!podeReabrirItemSelecionado(p)"
                      [title]="tituloReabrirItemSelecionado(p)" (click)="reabrirItemSelecionado(p)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
                      {{ rotuloReabrirSelecionados(p) }}
                    </button>
                    <button *ngFor="let relatorio of relatoriosImpressao" class="dropdown-item"
                      (click)="imprimirPedido.emit({nunota: p.nunota, view: relatorio.view}); dropdownAberto = null">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9V3h12v6"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
                      {{ relatorio.titulo }}
                    </button>
                  </div>
                </div>
              </td>
            </tr>

            <!-- Expansao: itens do pedido (abre abaixo da linha, igual ao Fluxo do Pedido de Venda) -->
            <tr *ngIf="itensAberto && itensNunota === p.nunota" class="linha-itens-expansao">
              <td colspan="15" class="td-itens">
                <div class="itens-container-inline">
                  <div class="itens-corpo">
                    <div class="itens-vazio" *ngIf="itensCarregando">Carregando itens...</div>
                    <div class="itens-vazio itens-erro" *ngIf="!itensCarregando && itensErro">{{ itensErro }}</div>
                    <div class="itens-vazio" *ngIf="!itensCarregando && !itensErro && itens.length === 0">Pedido sem itens.</div>
                    <div class="itens-scroll" *ngIf="!itensCarregando && itens.length > 0">
                      <table class="itens-tabela">
                        <thead>
                          <tr>
                            <th class="col-center" style="width:28px"><input type="checkbox" [checked]="todosItensMarcados" (click)="toggleTodosItens($event)" title="Marcar todos"></th>
                            <th class="col-center">ORD</th>
                            <th>PN</th>
                            <th class="col-center">UN</th>
                            <th class="col-right">QTD</th>
                            <th>FABRICANTE</th>
                            <th class="col-right">ESTOQUE</th>
                            <th class="col-center">CD</th>
                            <th class="col-right" title="Qtde Vendida no período (Aerosys + Sankhya)">QTDE VENDIDA</th>
                            <th class="col-right" title="Qtde Vendida no mesmo período do ano anterior">VEND. ANO ANT.</th>
                            <th class="col-right" title="Ponto de Pedido (Aerosys)">PONTO PEDIDO</th>
                            <th class="col-right" title="Qtde em outros Pedidos de Compra abertos (Aerosys)">QTDE OUTROS PED.</th>
                            <th class="col-right" title="Qtde em PréCompra Aberto/BackOrders (Aerosys)">QTDE PRÉCOMPRA AB/BK</th>
                            <th class="col-right" title="Estoque EUA (Aerosys)">ESTOQUE EUA</th>
                            <th class="col-right" title="Custo = Preço do Fabricante (U$)">CUSTO U$</th>
                            <th class="col-right" title="Custo U$ × cotação do dia">CUSTO R$</th>
                            <th class="col-right">TOTAL U$</th>
                            <th class="col-right">TOTAL R$</th>
                            <th>OBSERVAÇÃO</th>
                            <th>DESCRIÇÃO</th>
                            <th class="col-center">STATUS</th>
                            <th class="col-center" title="Código interno do produto (CODPROD)">ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let it of itens; let i = index" class="itens-linha" [class.itens-linha-sel]="itensMarcados.has(i)" (click)="selecionarItem(i, $event)">
                            <td class="col-center"><input type="checkbox" [checked]="itensMarcados.has(i)" (click)="selecionarItem(i, $event)"></td>
                            <td class="col-center">{{ it.sequencia || i + 1 }}</td>
                            <td style="cursor:pointer" title="Clique para copiar o PN" (click)="copiarPn(it.pn, $event)">{{ it.pn }}</td>
                            <td class="col-center">{{ it.unidade }}</td>
                            <td class="col-right">{{ it.quantidade | number:'1.0-4':'pt-BR' }}</td>
                            <td class="itens-desc" [title]="it.fabricante || ''">{{ it.fabricante || '—' }}</td>
                            <td class="col-right" [class.itens-est-zero]="!it.estoque">{{ it.estoque == null ? '—' : (it.estoque | number:'1.0-3':'pt-BR') }}</td>
                            <td class="col-center">{{ it.cd || '—' }}</td>
                            <td class="col-right">{{ it.qtdeVendas ?? '—' }}</td>
                            <td class="col-right">{{ it.qtdeVendasAnoAnt ?? '—' }}</td>
                            <td class="col-right">{{ it.pontoPedido ?? '—' }}</td>
                            <td class="col-right" [title]="it.pedidoOutros || ''">{{ it.qtdePedidoOutros ?? '—' }}</td>
                            <td class="col-right" [title]="it.dataPrecompraAbBk || ''">{{ it.qtdePrecompraAbBk ?? '—' }}</td>
                            <td class="col-right">{{ it.estoqueEua ?? '—' }}</td>
                            <td class="col-right">{{ it.custoUsd > 0 ? fmtDec(it.custoUsd) : '—' }}</td>
                            <td class="col-right">{{ it.custoBrl > 0 ? fmtDec(it.custoBrl) : '—' }}</td>
                            <td class="col-right">{{ it.totalUsd > 0 ? fmtDec(it.totalUsd) : '—' }}</td>
                            <td class="col-right">{{ it.totalBrl > 0 ? fmtDec(it.totalBrl) : '—' }}</td>
                            <td class="itens-desc" [title]="it.obs || ''">{{ it.obs || '—' }}</td>
                            <td class="itens-desc" [title]="it.descricao || ''">{{ it.descricao }}</td>
                            <td class="col-center"><span class="itens-status" [ngClass]="statusLegadoClass(it.statusItem || 'ABERTO')">{{ it.statusItem || 'ABERTO' }}</span></td>
                            <td class="col-center">{{ it.codprodInterno || '—' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            </ng-container>
          </tbody>
        </table>

        <!-- ── RODAPÉ: total + paginação ── -->
        <div class="tabela-rodape">
          <span class="rodape-total">{{ pedidosFiltrados.length }} pedido{{ pedidosFiltrados.length !== 1 ? 's' : '' }}</span>

          <div class="rodape-paginacao">
            <div class="por-pagina">
              <span>Exibir</span>
              <select [(ngModel)]="itensPorPagina" (ngModelChange)="onItensPorPaginaChange()" class="sel-pagina">
                <option *ngFor="let op of opcoesPorPagina" [value]="op">{{ op }}</option>
              </select>
              <span>por página</span>
            </div>

            <div class="pag-controles">
              <button class="pag-btn" (click)="irParaPagina(1)" [disabled]="paginaAtual === 1" title="Primeira">«</button>
              <button class="pag-btn" (click)="irParaPagina(paginaAtual - 1)" [disabled]="paginaAtual === 1" title="Anterior">‹</button>

              <ng-container *ngFor="let p of paginas">
                <button class="pag-btn" [class.pag-ativo]="p === paginaAtual" (click)="irParaPagina(p)">{{ p }}</button>
              </ng-container>

              <button class="pag-btn" (click)="irParaPagina(paginaAtual + 1)" [disabled]="paginaAtual === totalPaginas" title="Próxima">›</button>
              <button class="pag-btn" (click)="irParaPagina(totalPaginas)" [disabled]="paginaAtual === totalPaginas" title="Última">»</button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

  </div>

  <!-- Diálogo padrão (confirmações e resultados das ações) -->
  <div class="pc-dlg-overlay" *ngIf="dialogo" (click)="fecharDialogo(false)">
    <div class="pc-dlg-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
      <div class="pc-dlg-icon" [ngClass]="'pc-dlg-' + dialogo.tipo">
        <svg *ngIf="dialogo.tipo === 'sucesso'" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        <svg *ngIf="dialogo.tipo === 'erro'" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
        <svg *ngIf="dialogo.tipo === 'aviso' || dialogo.tipo === 'confirmar'" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
          <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
      </div>
      <h3 class="pc-dlg-titulo">{{ dialogo.titulo }}</h3>
      <p class="pc-dlg-msg">{{ dialogo.mensagem }}</p>
      <ul class="pc-dlg-detalhes" *ngIf="dialogo.detalhes.length">
        <li *ngFor="let d of dialogo.detalhes">{{ d }}</li>
      </ul>
      <div class="pc-dlg-footer">
        <button type="button" class="pc-dlg-btn" *ngIf="dialogo.tipo === 'confirmar'" (click)="fecharDialogo(false)">Cancelar</button>
        <button type="button" class="pc-dlg-btn-primary" [class.pc-dlg-btn-perigo]="dialogo.perigo"
          (click)="fecharDialogo(true)">{{ dialogo.textoConfirmar }}</button>
      </div>
    </div>
  </div>

  <div class="toast-funcoes" *ngIf="avisoFuncoes" [class.toast-erro]="avisoErro">{{ avisoFuncoes }}</div>
</div>
